import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import BaseDialog from '../ui/BaseDialog';
import { useLayoutState } from '@/provider/layouts/layoutContext';
import { useNavigate } from 'react-router-dom';

const RegenerateDialog = () => {
    const { t } = useTranslation('common');
    const { state, dispatch } = useLayoutState();
    const navigate = useNavigate();
    const handleOnConfirm = useCallback(() => {
        dispatch({ type: 'TOGGLE_DIALOG', payload: { key: 'regenerate', open: false } });
        navigate('/admin/settings', { state: { from: 'previewBarcode' } });
    }, []);
    const handleOnRegenerateClose = useCallback(
        () => dispatch({ type: 'TOGGLE_DIALOG', payload: { key: 'regenerate', open: false } }),
        [],
    );
    return (
        <>
            <BaseDialog
                open={state.dialogs.regenerate}
                maxWidth="md"
                dialogTitle={t('Preview Barcode Unavailable for This Store')}
                confirmButtonText={t('Configure Now')}
                cancelButtonText={t('Close')}
                onConfirm={handleOnConfirm}
                onClose={handleOnRegenerateClose}
                disableConfirm={state.loadings.regenerate}
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '1rem',
                        width: '100%',
                    }}
                >
                    <Typography>
                        {t(
                            'A preview cannot be generated because no applicable preview barcode is available for this store.',
                        )}
                        <br />
                        {t('This may be due to missing configuration or an invalid preview barcode being assigned.')}
                    </Typography>
                </div>
            </BaseDialog>
        </>
    );
};
export default RegenerateDialog;
